import { Link } from "react-router-dom";
import { categories } from "@/mocks/site";
import { movies } from "@/lib/media";

export default function CategoryShortcuts() {
  return (
    <section className="portal-container mt-8" aria-label="影视分类快捷入口">
      <div className="grid grid-cols-2 gap-3 md:gap-4 lg:grid-cols-4">
        {categories.map((category) => {
          const count = movies.filter((item) => item.type === category.key).length;
          return (
            <Link
              key={category.key}
              to={`/category/${category.key}`}
              className="group flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
            >
              <div className="flex items-center justify-between">
                <span className={`flex h-10 w-10 items-center justify-center rounded-md text-xl text-background-50 ${category.accent}`}>
                  <i className={category.icon} aria-hidden="true" />
                </span>
                <span className="font-heading text-xs tracking-wider text-foreground-400">{category.english}</span>
              </div>
              <div>
                <h3 className="flex items-center gap-1.5 font-heading text-base font-semibold text-foreground-950">
                  {category.name}
                  <i
                    className="ri-arrow-right-up-line text-sm text-accent-500 opacity-0 transition-opacity group-hover:opacity-100"
                    aria-hidden="true"
                  />
                </h3>
                <p className="mt-1 line-clamp-2 text-xs leading-5 text-foreground-500">{category.description}</p>
              </div>
              <p className="mt-auto text-xs text-foreground-400">
                共 <span className="font-semibold text-primary-700">{count}</span> 部作品
              </p>
            </Link>
          );
        })}
      </div>
    </section>
  );
}